import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { RespiratoryRateAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-respiratory-rate-and-effort-slot',
    templateUrl: './respiratory-rate-and-effort-slot.component.html',
    styleUrl: './respiratory-rate-and-effort-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RespiratoryRateSlotComponent implements SheetSlotComponentBase {

	action!: RespiratoryRateAction;
	value!: string | null;

	@Input('action') set updateAction(action: RespiratoryRateAction | null) {
		this.action = action as RespiratoryRateAction;
		this.value = this.action.breathsPerMinute?.toString() ?? null;
	}

	constructor() {
	}
}